import {
  getWxConfig
} from '@/api/weChart/wx'

const state = {
  wxConfig: {
    authTime: '', // 认证时间
    appId: '', // appid
    timestamp: '', // 认证事件
    nonceStr: '', // 认证随机字符串
    signature: '' // 加密码
  }
}

const actions = {
  /* 获取微信认证信息 */
  WX_GET_CONFIG ({ state, commit }, url) {
    return getWxConfig(url)
  }
}

const mutations = {
  /* 设置微信认证配置所需参数 */
  WX_COMMIT_CONFIG (state, data) {
    if (data) {
      state.wxConfig.authTime = new Date().getTime()
      state.wxConfig.appId = data.appId
      state.wxConfig.timestamp = data.timestamp
      state.wxConfig.nonceStr = data.nonceStr
      state.wxConfig.signature = data.signature
    }
  }
}

const getters = {}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/wx.js